module.exports = "<app-navigation></app-navigation>\n<div id=\"main\" class=\"application-container\">\n    <router-outlet></router-outlet>\n    <app-footer></app-footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main